export const ActionTypes = {
  LOADING: "ADD_CRITERIA_ROWS_LOADING",
  ERROR: "ADD_CRITERIA_ROWS_ERROR",
  SUCCESS: "ADD_CRITERIA_ROWS_SUCCESS",
  // TOGGLE_POPUP: "TOGGLE_POPUP"
};
